import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=0b84f50c&"
import script from "./quit.vue?vue&type=script&lang=js&"
export * from "./quit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports